import Container from "../../../components/element/container";
import Col from "../../../components/element/col";
import Row from "../../../components/element/row";
import Image from "../../../components/element/image";
import {
  FastPayment,
  HighOffer,
  NoPaperwork,
  ProInspector,
} from "../../../assets/images";
import { useTranslation } from "react-i18next";

export default function ConsignWhy() {
  const { t } = useTranslation();

  const whyList = [
    {
      img: ProInspector,
      highlight: "Professional",
      title: "Inspectors",
      subtitle:
        "Your car will be inspected by trained and experienced professionals",
    },
    {
      img: NoPaperwork,
      highlight: "No",
      title: "Paperwork Hassle",
      subtitle:
        "We handle all the paper work while you relax, it's that simple",
    },
    {
      img: HighOffer,
      highlight: "Best",
      title: "Market Offer",
      subtitle: "We connect you with genuine buyers to get you the best offer",
    },
    {
      img: FastPayment,
      highlight: "Fast & Secure",
      title: "Payment",
      subtitle: "Get paid securely and on time with our trusted payment system",
    },
  ];

  return (
    <Container className="consign-why">
      <Col className="_col why-heading">
        <h3 className="_label consign-title">
          {t("Why Choose")} <span>{t("DCAR")}</span>
        </h3>
        <p className="_label consign-subtitle">
          {t("You may also like these similar cars")}
        </p>
      </Col>
      <Col className="_col why-list">
        {whyList.map((why, whyIndex) => (
          <Row className="_row why-item" key={whyIndex}>
            <Image
              alt=""
              src={why.img}
              className="_img"
              loading="eager"
              width={110}
              height={110}
            />
            <Col className="_col why-content">
              <h4 className="_label why-title">
                <span>{t(why.highlight)}</span> {t(why.title)}
              </h4>
              <p className="_label why-subtitle">{t(why.subtitle)}</p>
            </Col>
          </Row>
        ))}
      </Col>
    </Container>
  );
}
